var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._b({class:_vm.buttonClass,on:{"click":function($event){return _vm.$emit('click', $event)}}},'b-button',_vm.$attrs,false),[_vm._t("icon",function(){return [(!!_vm.iconClass)?_c('i',{staticClass:"fas",class:_vm.iconClass}):_vm._e()]}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }